import { SalesOrderComment } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1320. 受注案件コメント登録
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_comments
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  content: string;
  content_json: string;
  parent_id?: number;
};
const createSalesOrderComment = (props: Props): Promise<SalesOrderComment> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_comments`,
    props);
};
export const useCreateSalesOrderComment = () => {
  return useMutation({
    mutationFn: createSalesOrderComment
  });
};